import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-zinc-supplement',
  imports: [UpsellCardComponent],
  styleUrl: './zinc-supplement.component.scss',
  templateUrl: './zinc-supplement.component.html',
})
export class ZincSupplementComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.ZincSupplement;
}
